/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  AICareerFinancialsSVG,
  AICareerPathSVG,
  AIMockInterviewSVG,
} from '@components/userDocuments/editDocument/editJournal/toolset/assets/icons';
import {
  IconSvg,
  ImportAppSVG,
  AIResumeReviewIcon,
  OptimizeLinkedinSVG,
  QuestionGeneratorSVG,
} from './appsSvgs';

export const data = {
  header: {
    title: 'Empowering millions to launch their next career journey!',
    subtitle:
      'Get started with following apps for Crafting and Perfecting Resumes and Cover Letters for Every Career Opportunity!',
  },

  formatType: {
    resume: [
      {
        title: 'Create a resume from scratch',
        key: 'createResume',
        bullets: [
          'Write ATS friendly resume',
          'Take help from resume assistant',
          'On-the-go AI resume review',
        ],
        svg: <IconSvg />,
        buttonText: 'Create',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/hWvxll2legc',
      },
      {
        title: 'Import an existing resume (.pdf)',
        key: 'importResume',
        bullets: [
          'Import your resume within minutes',
          'Once imported, review using AI',
          'Update your resume as per job role',
        ],
        svg: <ImportAppSVG />,
        buttonText: 'Import',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/l_Z7UjqmwRA',
      },
      {
        title: 'AI resume review',
        key: 'aiResumeReview',
        bullets: [
          'Import or choose your resume',
          'Provide your career experience',
          'AI reviews your resume in 30 sec',
        ],
        svg: <AIResumeReviewIcon />,
        buttonText: 'AI review',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/BsxGGdKeTgE',
      },
    ],
    coverLetter: [
      {
        title: 'Create a cover letter from scratch',
        key: 'createCoverLetter',
        bullets: [
          'Write ATS friendly cover letter',
          'Take help from cover letter assistant',
          'On-the-go AI cover letter review',
        ],
        svg: <IconSvg />,
        buttonText: 'Create',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/BPgFY9B48lg',
      },
      {
        title: 'AI cover letter review',
        key: 'aiCoverLetterReview',
        bullets: [
          'Import or choose your cover letter',
          'Pick your career stage',
          'AI reviews your data in 30 sec',
        ],
        svg: <AIResumeReviewIcon />,
        buttonText: 'AI review',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/WemgiMY6qvg',
      },
      {
        title: 'AI generated cover letter',
        key: 'aiGeneratedCL',
        bullets: [
          'Choose an existing resume',
          'AI generates a sample cover letter',
          'Customize it for any job role',
        ],
        svg: <AIResumeReviewIcon />,
        buttonText: 'Generate',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/9ytHd09Ty00',
      },
    ],

    interviewQuestionGenerator: [
      {
        title: 'Interview question generator',
        key: 'questionsGenerator',
        bullets: [
          'Write ATS friendly cover letter',
          'Take help from cover letter assistant',
          'On-the-go AI cover letter review',
        ],
        svg: <QuestionGeneratorSVG />,
        buttonText: 'Generate',
        onClick: () => {},
        quickPeekLink: 'https://www.youtube.com/embed/jlpepVgKG5c',
      },
      {
        title: 'AI Mock Interview',
        key: 'aiMockInterview',
        svg: <AIMockInterviewSVG />,
        buttonText: 'Start',
        onClick: () => {},
        quickPeekLink: '',
      },
    ],

    optimizeLinkedIn: [
      {
        title: 'LinkedIn optimization',
        key: 'linkedInOptimizer',
        buttonText: 'Optimize',
        svg: <OptimizeLinkedinSVG />,
        quickPeekLink: 'https://www.youtube.com/embed/fRRiuc_iKlQ',
        onClick: () => {},
      },
    ],

    aiCareerPath: [
      {
        title: 'AI career path',
        key: 'aiCareerPath',
        buttonText: 'Generate',
        svg: <AICareerPathSVG isActive={false} />,
        quickPeekLink: 'https://www.youtube.com/embed/mAPN-uo8Hos',
        onClick: () => {},
      },
      {
        title: 'AI career financials',
        key: 'aiCareerFinancials',
        buttonText: 'Generate',
        svg: <AICareerFinancialsSVG isActive={false} />,
        quickPeekLink: 'https://www.youtube.com/embed/x96C6lVCIOM',
        onClick: () => {},
      },
    ],
  },
};

export const AppKeys = {
  CREATE_RESUME: 'createResume',
  IMPORT_RESUME: 'importResume',
  AI_RESUME_REVIEW: 'aiResumeReview',
  CREATE_COVER_LETTER: 'createCoverLetter',
  AI_COVER_LETTER_REVIEW: 'aiCoverLetterReview',
  AI_GENERATED_CL: 'aiGeneratedCL',
  LINKEDIN_OPTIMIZER: 'linkedInOptimizer',
  QUESTIONS_GENERATOR: 'questionsGenerator',
  AI_CAREER_PATH: 'aiCareerPath',
  AI_MOCK_INTERVIEW: 'aiMockInterview',
  AI_CAREER_FINANCIALS: 'aiCareerFinancials',
};

export const coverLetterTypes = {
  GENERIC: 'generic',
  JOB_SPECIFIC: 'job-specific',
};

export const fileTypes = {
  UPLOAD_FILE: 'uploadFile',
  WISEDOC_FILE: 'wisedocFile',
};

export const sectionType = {
  RESUME: 'resume',
  COVER_LETTER: 'coverLetter',
  LINKEDIN: 'linkedin',
  INTERVIEW_QUESTION_GENERATOR: 'questioinsGenerator',
  AI_CAREER_PATH: 'aiCareerPath',
};
